import styled from "styled-components"
import React from "react"
import { useSelector } from "react-redux"
import { DropdownButton, Dropdown } from "react-bootstrap"

import { StoreType } from "client/store"
import { Input, CrossIcon } from "client/components"

export const SelectDropdown = styled(DropdownButton)<{
    row?: any
    search?: any
    fit?: any
}>`
    margin-right: ${(props) => (props.row ? "10px" : "0")};
    min-width: ${(props) => (props.search ? "130px" : "unset")};

    & > .btn, & > .btn:active, & > .btn:focus, & > .btn:active:focus {
        position: relative;
        width: 100%;
        height: ${(props) => (props.fit ? "fit-content" : (props.search ? "39px" : "33px"))};
        min-height: ${(props) => (props.fit ? "33px" : "unset")};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-radius: 0;
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        padding: ${(props) => (props.row || props.search ? "2px 28px 2px 12px" : "2px 12px")};
        margin-bottom: ${(props) => (props.row || props.search ? "0" : "8px")};
        text-align: left;
        font-size: ${(props) => props.theme.fontSizes.md}px;
        color: ${(props) => props.theme.inputColor};
        background: ${(props) => props.theme.inputBackground} !important;

        &::after {
            content: "";
            display: block;
            border-top: 4px solid ${(props) => props.theme.inputColor};
            border-right: 4px solid transparent;
            border-bottom: 0;
            border-left: 4px solid transparent;
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    & > .btn:active, & > .btn:focus, & > .btn:active:focus, & > .btn-primary:active {
        color: ${(props) => props.theme.inputFocusColor};
    }

    & > .dropdown-menu {
        width: ${(props) => (props.row || props.search ? "fit-content" : "100%")};
        min-width: 100%;
        max-height: 350px;
        overflow-y: scroll;
        box-sizing: border-box;
        padding: 0;
        border-radius: 0;
        border: 1px solid ${(props) => props.theme.selectDropdownBackground};
        background: ${(props) => props.theme.selectDropdownBackground};
    }
`
export const SelectDropdownItem = styled(Dropdown.Item)<{
    size?: "sm" | "md"
}>`
    display: block;
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: ${(props) => {
        switch (props.size) {
            case "sm":
                return "3px 24px 3px 12px"
            case "md":
            default:
                return "6px 24px 6px 12px"
        }
    }};
    text-decoration: none;
    font-size: ${(props) => props.theme.fontSizes.md}px;
    color: ${(props) => props.theme.selectDropdownItemColor};
    background: transparent;
    transition: ${(props) => props.theme.defaultTransition};

    &:focus {
        outline: none;
        background: transparent;
        color: ${(props) => props.theme.selectDropdownItemColor};
    }

    &:hover {
        text-decoration: none;
        color: ${(props) => props.theme.selectDropdownItemHoverColor};
        background: ${(props) => props.theme.selectDropdownHoverBackground};
        transition: ${(props) => props.theme.defaultTransition};
    }
`


// delete dropdown item
interface DeleteDropdownProps extends React.HTMLAttributes<HTMLDivElement> {}
const DeleteWrapper = styled.div`
    position: absolute;
    right: 0;
    top: 6px;
    margin: 0 6px;
    line-height: 24px;
    user-select: none;
    cursor: pointer;

    & > i {
        font-weight: bold;
        font-size: ${(props) => props.theme.fontSizes.md}px;
        color: ${(props) => props.theme.selectDropdownDelete};
        transition: ${(props) => props.theme.defaultTransition};

        &:hover {
            color: ${(props) => props.theme.selectDropdownDeleteHover};
            transition: ${(props) => props.theme.defaultTransition};
        }
    }
`
export const DeleteDropdownItem = (props: DeleteDropdownProps) => (
    <DeleteWrapper {...props}>
        <CrossIcon />
    </DeleteWrapper>
)


// dropdown search
const SearchInputWrapper = styled.div`
    display: flex;
    margin: 5px;
    background: ${(props) => props.theme.selectDropdownSearchBackground};
`
const SearchInputStyled = styled(Input)`
    display: flex;
    flex-grow: 1;
    margin: 0;
    font-size: ${(props) => props.theme.fontSizes.md}px;
    background: inherit;
`
const ClearSearch = styled.div`
    display: flex;
    align-items: center;
    margin: 0 8px;
    user-select: none;
    cursor: pointer;

    & > i {
        font-weight: bold;
        font-size: ${(props) => props.theme.fontSizes.lg}px;
        color: ${(props) => props.theme.selectDropdownClearSearch};
        transition: ${(props) => props.theme.defaultTransition};

        &:hover {
            color: ${(props) => props.theme.selectDropdownClearSearchHover};
            transition: ${(props) => props.theme.defaultTransition};
        }
    }
`
export interface SelectDropdownSearchProps {
    value: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onClearSearch: () => void
}
export const SelectDropdownSearch = ({
    value = "",
    onChange = null,
    onClearSearch = null,
}: SelectDropdownSearchProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <SearchInputWrapper>
            <SearchInputStyled
                placeholder={lang.searchPlaceholder}
                value={value}
                onChange={onChange}
                autoComplete="off"
            />
            <ClearSearch onClick={onClearSearch}>
                <CrossIcon />
            </ClearSearch>
        </SearchInputWrapper>
    )
}
